import React, { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
}

/**
 * Reusable SEO component to manage document head metadata.
 * It updates the page title and meta description dynamically.
 */
export const SEO: React.FC<SEOProps> = ({ title, description }) => {
  useEffect(() => {
    // Update the document title
    document.title = title;

    // Update or create the meta description tag
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
    
    // Optional: Log for verification during development
    // console.log(`SEO Updated: ${title}`);
  }, [title, description]);

  return null;
};